<script lang="ts" setup>
import { PlusCircledIcon } from "@radix-icons/vue"
import { Badge } from "@/components/ui/badge"
import { Command, CommandEmpty, CommandGroup, CommandList } from "@/components/ui/command"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { Separator } from "@/components/ui/separator"
import { types } from "@/store"
import { Button } from "@components/ui/button"
import { Input } from "@components/ui/input"

const emit = defineEmits(["update:modelValue"])

// type Props = {
//     modelValue: string[]
// }

// const props = defineProps<Props>()
// const selectedBranches = ref(props.modelValue)
// watch(selectedBranches, (branches) => emit('update:modelValue', branches))
// const selectedBranches = computed({
//     get: () => props.modelValue,
//     set: (branches) => emit('update:modelValue', branches)
// })
// const selectedBranches = defineModel() or
const selectedTypes = defineModel("modelValue")
// const selectedBranches = defineModel('branches')
</script>
<template>
    <Popover>
        <PopoverTrigger as-child>
            <Button variant="outline" size="sm" class="h-8 border-dashed">
                <PlusCircledIcon class="mr-2 h-4 w-4" />
                Type
                <template v-if="selectedTypes.length > 0">
                    <Separator orientation="vertical" class="mx-2 h-4" />
                    <Badge variant="secondary" class="rounded-sm px-1 font-normal lg:hidden">
                        {{ selectedTypes.length }}
                    </Badge>
                    <div class="hidden space-x-1 lg:flex">
                        <Badge v-if="selectedTypes.length > 2" variant="secondary" class="rounded-sm px-1 font-normal"> {{ selectedTypes.length }} selected </Badge>

                        <template v-else>
                            <Badge v-for="item in selectedTypes" variant="secondary" class="rounded-sm px-1 font-normal">
                                {{ item }}
                            </Badge>
                        </template>
                    </div>
                </template>
            </Button>
        </PopoverTrigger>
        <PopoverContent class="w-[200px] p-0" align="start">
            <Command>
                <!-- <CommandInput placeholder="Branch" /> -->
                <CommandList>
                    <CommandEmpty>No results found.</CommandEmpty>
                    <CommandGroup>
                        <div v-for="item in types" class="flex items-center space-2 p-2">
                            <input type="checkbox" :id="item.id" v-model="selectedTypes" :value="item.name" />
                            <label class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ml-2" :for="item.name">{{ item.name }}</label>
                        </div>
                    </CommandGroup>
                </CommandList>
            </Command>
            <template v-if="selectedTypes.length > 0">
                <Button variant="ghost" class="justify-center text-center" @click="() => (selectedTypes = [])"> Clear Filters </Button>
            </template>
        </PopoverContent>
    </Popover>
</template>
